import React from "react";
import ServicePage from "../components/ServicePage";
import bannerimg from "../../media/bannerimg.jpg";
import heroImg from "../../media/taxesmain.jpg"; // Replace with tax-specific image if available
import sideImg1 from "../../media/taximg1.jpg";
import sideImg2 from "../../media/taximg2.jpg";
import ctaBg from "../../media/accountingmain.png";
import usePageTitle from "../components/usePageTitle";

const Taxes = () => {
  usePageTitle("Taxes");
  return (
    <ServicePage
      title="Taxes"
      breadcrumb="Taxes"
      bgImage={bannerimg}
      heroImg={heroImg}
      sectionTitle="Strategic Tax Planning & Preparation Services"
      description="Tax strategy is more than filing forms—it's about planning ahead. At Aspen SR, we provide personalized tax planning and preparation services for individuals, businesses, and nonprofits. Our approach ensures that you remain compliant while maximizing tax-saving opportunities and avoiding year-end surprises. From quarterly estimates to multi-state compliance, our team offers clarity and confidence every step of the way."
      overviewItems={[
        "Individual and business tax return preparation.",
        "Year-round strategic tax planning services.",
        "Nonprofit tax compliance and reporting.",
        "State, federal, and multi-jurisdictional support.",
      ]}
      featureItems={[
        {
          icon: "bi-cash-coin",
          title: "Maximized Savings",
          text: "We focus on tax strategies that reduce your overall liability.",
        },
        {
          icon: "bi-people",
          title: "Tailored Service",
          text: "Customized tax solutions for individuals, businesses, and nonprofits.",
        },
        {
          icon: "bi-calendar2-check",
          title: "Timely Compliance",
          text: "On-time filings and proactive reminders to keep you on track.",
        },
      ]}
      faqList={[
        {
          id: 1,
          question:
            "Do you offer services for both individuals and businesses?",
          answer:
            "Yes, we provide tax preparation and planning for individuals, small businesses, and nonprofit organizations.",
        },
        {
          id: 2,
          question: "Can you help with multi-state tax compliance?",
          answer:
            "Absolutely. We support clients with multi-jurisdictional filings, including state-specific tax laws.",
        },
        {
          id: 3,
          question: "Do you offer tax services year-round?",
          answer:
            "Yes, our services include year-round planning, quarterly estimates, and mid-year tax reviews.",
        },
        {
          id: 4,
          question: "Can you handle nonprofit tax returns?",
          answer:
            "Yes, we prepare Form 990 and related filings for a variety of nonprofit entities.",
        },
      ]}
      sideImage1={sideImg1}
      sideImage2={sideImg2}
      ctaBg={ctaBg}
      phoneNumber="(+1) 720-412-7990"
    />
  );
};

export default Taxes;
